export default __webpack_public_path__ + "static/media/parkinglot-color.bd72e379.svg";